<template>
    <div>
        <el-form label-position="top" @submit.native.prevent>
            <el-row class="u-mt-10 u-mb-20" :gutter="10">
                <el-col :xs="24" :sm="8" :md="6">
                    <el-form-item label="Período diagnóstico">
                        <el-select v-model="filtro.periodo_id" placeholder="Selecione" @change="load" clearable style="width: 100%;">
                            <el-option v-for="p in periodos" :key="p.id" :label="p.descricao" :value="p.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="10">
                    <el-form-item label="Professor(a) regente">
                        <el-select v-model="filtro.servidor_id"
                                   filterable remote :remote-method="searchServidor"
                                   :loading="loadingServidor" clearable
                                   placeholder="Digite o nome do(a) professor(a)..."
                                   @change="load"
                                   style="width: 100%;">
                            <el-option v-for="s in servidores" :key="s.id" :label="s.nome" :value="s.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div v-if="!filtro.periodo_id || !filtro.servidor_id" class="u-text-center u-mt-25" style="color: #909399;">
            Selecione o período diagnóstico e o(a) professor(a) para visualizar as turmas.
        </div>

        <div v-else>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <div v-else>
                <div class="container-table" v-if="items.length">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Escola</th>
                                <th>Curso/Ano</th>
                                <th>Turma</th>
                                <th style="width: 90px;">Matric.</th>
                                <th style="width: 80px;">Lanç.</th>
                                <th style="width: 130px;">Status</th>
                                <th style="width: 160px;" class="u-text-center">Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.turma_id"
                                :style="item.inconsistente ? 'background:#fff5f5;' : ''">
                                <td>{{ item.instituicao_nome || '—' }}</td>
                                <td>{{ item.curso_nome || '—' }}</td>
                                <td>{{ item.turma_nome }}</td>
                                <td>{{ item.matriculados }}</td>
                                <td>{{ item.lancados }}</td>
                                <td>
                                    <span v-if="item.status === 0" style="color: #909399;">Não iniciada</span>
                                    <span v-else-if="item.status === 1" style="color: #e6a23c;">Rascunho</span>
                                    <span v-else-if="item.status === 2" style="color: #67c23a;">Concluído</span>
                                    <span v-else-if="item.status === 3" style="color: #409eff;">Enviado à supervisão</span>
                                </td>
                                <td class="u-text-center acao">
                                    <router-link :to="urlLancamento(item)">
                                        <el-button type="primary" size="mini" plain>
                                            <i class="el-icon-edit"></i> {{ item.tabulacao_id ? 'Editar' : 'Iniciar' }}
                                        </el-button>
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="u-text-center u-mt-25" style="color: #909399;">
                    Este(a) professor(a) não tem turmas enturmadas no período letivo atual.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tipo: { type: String, required: true } // 'BASE' | 'DESENHO'
    },
    data: () => ({
        statusList: true,
        loadingServidor: false,
        periodos: [],
        servidores: [],
        filtro: { periodo_id: '', servidor_id: '' },
        items: []
    }),
    computed: {
        rotaBase () {
            return this.tipo === 'DESENHO' ? '/admin/tabulacao/professor/desenho' : '/admin/tabulacao/professor/base'
        }
    },
    mounted () {
        this.carregarPeriodos()
    },
    methods: {
        carregarPeriodos () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/periodo-diagnostico/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => {
                    this.periodos = (r.data || []).filter(p => p.status === 1)
                    if (this.periodos.length === 1) this.filtro.periodo_id = this.periodos[0].id
                })
        },
        searchServidor (query) {
            if (!query) { this.servidores = []; return }
            this.loadingServidor = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/servidor/searchByNome`,
                { query: query },
                this.$store.getters.getHeaderAuth
            ).then(response => { this.servidores = response.data || [] })
              .catch(() => {}).finally(() => { this.loadingServidor = false })
        },
        load () {
            if (!this.filtro.periodo_id || !this.filtro.servidor_id) return
            this.statusList = false
            this.items = []
            const url = `${this.$store.state.config.baseUrlApi}/api/tabulacao/listaTurmasProfessor/${this.filtro.servidor_id}/${this.filtro.periodo_id}/${this.tipo}`
            this.$axios.get(url, this.$store.getters.getHeaderAuth)
                .then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    } else {
                        this.items = r.data || []
                    }
                    this.statusList = true
                })
                .catch(error => { this.statusList = true; this.$store.commit('throwException', error) })
        },
        urlLancamento (item) {
            return `${this.rotaBase}/turma/${item.turma_id}/periodo/${this.filtro.periodo_id}`
        }
    }
}
</script>
